/**
 * StepIndicator — visual 1·2·3 progress bar shown above the step content
 * in the physical + service checkout variants. The digital variant
 * (2-step summary+verify flow) does NOT use this component.
 *
 * SPEC-244 · partición VERBATIM de
 * frontend/src/components/market/checkout-modal.tsx (2.637 L).
 *
 * The `aria-current="step"` attribute is set on the active step per
 * anti-P-044 (ARIA). Step labels come from the parent (physical uses
 * "1. Detalles / 2. Resumen / 3. Confirmar"; service uses
 * "1. Reserva / 2. Resumen / 3. Confirmar").
 */

import type { Step } from '../types';

// ─── Component ───────────────────────────────────────────────────────────────

export interface StepIndicatorProps {
  /** Current active step. */
  step: Step;
  /** Label for step 1 ("Detalles" / "Reserva"). */
  firstLabel: string;
}

export function StepIndicator({ step, firstLabel }: StepIndicatorProps) {
  return (
    <ol
      className="flex items-center justify-center gap-2 text-xs text-muted-foreground mb-2"
      aria-label="Progreso del checkout"
    >
      <li
        aria-current={step === 'details' ? 'step' : undefined}
        className={
          step === 'details'
            ? 'font-semibold text-foreground'
            : step === 'summary' || step === 'verify'
              ? 'text-emerald-600 dark:text-emerald-400'
              : ''
        }
      >
        1. {firstLabel}
      </li>
      <span aria-hidden="true">→</span>
      <li
        aria-current={step === 'summary' ? 'step' : undefined}
        className={
          step === 'summary'
            ? 'font-semibold text-foreground'
            : step === 'verify'
              ? 'text-emerald-600 dark:text-emerald-400'
              : ''
        }
      >
        2. Resumen
      </li>
      <span aria-hidden="true">→</span>
      <li
        aria-current={step === 'verify' ? 'step' : undefined}
        className={step === 'verify' ? 'font-semibold text-foreground' : ''}
      >
        3. Confirmar
      </li>
    </ol>
  );
}
